import { Icon, IconsEnum } from 'components/Icons';
import { RideStatus, Stato } from 'features/ippica/types';
import { useEffect, useMemo, useRef, useState } from 'react';

import { AppFragment } from 'enums/path-fragment';
import classNames from 'classnames';
import { ippicaToggleNavMobile } from 'features/ippica/ippicaSlice';
import styles from './IppicaNavCorsaBox.module.scss';
import { useDispatch } from 'react-redux';
import { useIsDarkTheme } from 'hooks/useIsDarkTheme';
import { useRouter } from 'next/router';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaNavCorsaBoxProps = {
  numeroAvvenimento: number;
  numeroCorsa: number;
  codiceProgramma: number;
  orarioPartenza: Date;
  isTris: boolean;
  isTot: boolean;
  isTqq: boolean;
  stato: Stato;
};

export const IppicaNavCorsaBox = ({
  numeroAvvenimento,
  numeroCorsa,
  codiceProgramma,
  orarioPartenza,
  isTris,
  isTot,
  isTqq,
  stato,
}: IppicaNavCorsaBoxProps) => {
  const hours = orarioPartenza.getHours();
  const minutes = orarioPartenza.getMinutes().toString().padStart(2, '0');

  const dispatch = useDispatch();

  const { isDarkMode } = useIsDarkTheme();

  let isAnnullata = stato.toUpperCase() === RideStatus.ANNULLATA.toUpperCase();

  const { query, push } = useRouter();

  const isActive = useMemo(
    () => query.details === `${codiceProgramma}-${numeroAvvenimento}`,
    [codiceProgramma, numeroAvvenimento, query.details]
  );

  const { isNavMobileOpened } = useTypedSelector((state) => state.ippica);

  const handleToogleNavMobile = () => {
    dispatch(ippicaToggleNavMobile(!isNavMobileOpened));
    push(`/${AppFragment.Ippica}/${codiceProgramma}-${numeroAvvenimento}`);
  };

  return (
    <button type="button" className={styles.linkWrapper} onClick={handleToogleNavMobile}>
      <div
        data-testid={`corsa-${numeroCorsa}-${isActive}`}
        className={classNames(styles.container, {
          [styles.active]: isActive,
        })}
      >
        <span className={styles.number}>{numeroCorsa}</span>
        <p className={classNames(styles.wrapper, { [styles.cancelled]: isAnnullata })}>
          <span className={styles.hour}>{hours + ':' + minutes}</span>
          {!isAnnullata && (
            <span className={styles.iconWrapper}>
              <Icon
                iconId={
                  IconsEnum[
                    `LEGENDA_${stato.toUpperCase().replace(' ', '')}_${
                      isDarkMode ? 'DARK' : 'LIGHT'
                    }` as keyof typeof IconsEnum
                  ]
                }
                className={styles.icon}
              />
            </span>
          )}
        </p>

        {isAnnullata && (
          <span>
            <Icon
              iconId={
                IconsEnum[
                  `LEGENDA_${stato.toUpperCase().replace(' ', '')}_${
                    isDarkMode ? 'DARK' : 'LIGHT'
                  }` as keyof typeof IconsEnum
                ]
              }
              className={styles.iconAnnullata}
            />
          </span>
        )}
        {isTot && (
          <span>
            <Icon
              iconId={IconsEnum[`LEGENDA_TOT_${isDarkMode ? 'DARK' : 'LIGHT'}` as keyof typeof IconsEnum]}
              className={styles.iconTot}
            />
          </span>
        )}
        {isTris && !isTqq && (
          <Icon
            iconId={IconsEnum[`LEGENDA_TRIS_${isDarkMode ? 'DARK' : 'LIGHT'}` as keyof typeof IconsEnum]}
            className={styles.iconTris}
          />
        )}
        {isTqq && (
          <Icon
            iconId={IconsEnum[`LEGENDA_TQQ_${isDarkMode ? 'DARK' : 'LIGHT'}` as keyof typeof IconsEnum]}
            className={styles.iconTqq}
          />
        )}
      </div>
    </button>
  );
};
